import { TalkdeskChatbotPlugin } from 'packages/talkdesk-chatbot/plugin';

export interface AcpConfigurationService {
  getTalkdeskTouchpointId(): Promise<string>;
}

export interface TalkDeskWebChat {
  open: () => void;
  close: () => void;
  reset: () => void;
  toggle: () => void;
  init: any;
  isVisible: () => boolean;
  onCloseWebchat: () => void;
  onOpenWebchat: () => void;
  setContextParam: (val: any) => void;
  destroy: () => void;
}

declare global {
  interface Window {
    TalkdeskChatSDK: any;
    talkDeskWebChat: TalkDeskWebChat;
  }
}

export class AcpTalkdeskChatbotPlugin {
  permission: boolean;

  constructor(
    private webapiResource: nsWebclient.WebapiResourceService,
    private nsPermissions: nsUtils.NsPermissionsService
  ) {
    'ngInject';
  }

  getTouchpointId = this.webapiResource<{ items: any[] }, any>({
    method: 'POST',
    path: '/v2/configuration',
    format: 'json'
  });

  async init() {
    this.permission = await this.nsPermissions.requestPermission(
      'isTalkdeskChatbotEnabled'
    );

    const {
      'talkdesk.chatbot.touchpoint.id': touchpointId
    } = await this.getTouchpointId({
      items: ['talkdesk.chatbot.touchpoint.id']
    });
    // //const touchpointId = await this.acpConfigurationService.getTalkdeskTouchpointId();
    new TalkdeskChatbotPlugin(this.permission, touchpointId);
  }

  triggerWebAction() {
    const logAction = this.webapiResource<{ action: string }, void>({
      method: 'POST',
      path: `/v2/log/action`,
      format: 'json'
    });

    logAction({ action: 'CHATBOT_CLICKED' });
  }

  toggle(authed = false) {
    if (window.talkDeskWebChat) {
      if (authed) {
        this.triggerWebAction();
      }

      window.talkDeskWebChat.toggle();
    }
  }
}
